<template>
    <div>
        <svg :width="iconSize" :height="iconSize" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M20.2214 10.7517C20.2404 10.5036 20.25 10.2529 20.25 9.99993C20.25 8.47576 19.9003 7.03328 19.2767 5.74835C18.0396 6.92269 16.5671 7.85146 14.9374 8.45653C14.9789 8.96552 15 9.48026 15 9.99993C15 11.1011 14.9051 12.1802 14.7229 13.2293C16.7163 12.7277 18.5717 11.8792 20.2214 10.7517Z"
                :fill="color" 
            />
            <path
                d="M13.1343 13.5501C13.374 12.4043 13.5 11.2168 13.5 9.99993C13.5 9.63154 13.4885 9.26586 13.4657 8.90321C12.5141 9.12991 11.521 9.24993 10.5 9.24993C9.47896 9.24993 8.48594 9.12991 7.5343 8.90321C7.51155 9.26586 7.5 9.63154 7.5 9.99993C7.5 11.2168 7.62601 12.4043 7.8657 13.5501C8.72458 13.6817 9.60432 13.7499 10.5 13.7499C11.3957 13.7499 12.2754 13.6817 13.1343 13.5501Z"
                :fill="color" 
            />
            <path
                d="M8.27224 15.119C9.00278 15.2054 9.7462 15.2499 10.5 15.2499C11.2538 15.2499 11.9972 15.2054 12.7278 15.119C12.214 16.7746 11.4575 18.3235 10.5 19.724C9.54247 18.3235 8.78602 16.7746 8.27224 15.119Z"
                :fill="color" 
            />
            <path
                d="M6.27705 13.2293C6.09493 12.1802 6 11.1011 6 9.99993C6 9.48026 6.02114 8.96552 6.06261 8.45653C4.43286 7.85146 2.96039 6.92269 1.72333 5.74835C1.09973 7.03328 0.75 8.47576 0.75 9.99993C0.75 10.2529 0.759636 10.5036 0.778555 10.7517C2.42826 11.8792 4.28374 12.7277 6.27705 13.2293Z"
                :fill="color" 
            />
            <path
                d="M19.8561 12.7525C18.8404 16.2104 15.9597 18.8705 12.3776 19.5693C13.244 18.1123 13.9185 16.5278 14.3664 14.8508C16.3263 14.44 18.1736 13.7231 19.8561 12.7525Z"
                :fill="color" 
            />
            <path
                d="M1.14395 12.7525C2.82642 13.7231 4.67372 14.44 6.63356 14.8508C7.08146 16.5278 7.75602 18.1123 8.62242 19.5693C5.04027 18.8705 2.15964 16.2104 1.14395 12.7525Z"
                :fill="color" 
            />
            <path
                d="M12.3776 0.430554C14.8991 0.92245 17.0731 2.3862 18.4937 4.41599C17.4351 5.48484 16.1637 6.34251 14.7483 6.92017C14.362 4.58282 13.5435 2.39132 12.3776 0.430554Z"
                :fill="color" 
            />
            <path
                d="M10.5 0.275879C11.9287 2.36548 12.9097 4.78537 13.305 7.39744C12.4083 7.62756 11.4684 7.74993 10.5 7.74993C9.53156 7.74993 8.59169 7.62756 7.69503 7.39744C8.0903 4.78537 9.07133 2.36548 10.5 0.275879Z"
                :fill="color" 
            />
            <path
                d="M8.62242 0.430552C7.45648 2.39132 6.63795 4.58282 6.25171 6.92017C4.83629 6.34251 3.56489 5.48484 2.50635 4.41599C3.92689 2.3862 6.10085 0.922447 8.62242 0.430552Z"
                :fill="color" 
            />
        </svg>
    </div>
</template>

<script>
export default {
    name: 'IconSvgConnection',
    props: {
        color: {
            type: String,
            default: '#000000',
        },
        size: {
            type: Number,
            default: null
        }
    },
    computed: {
        iconSize() {
            return this.size ? `${this.size}px` : '44px'
        }
    }
};
</script>

<style scoped></style>